import { createSlice } from "@reduxjs/toolkit";
import {
    getUserList,
    getUserDetail,
    addUser,
    updateUser,
    deleteUser,
} from './thunk';

export const initialState = {
    userList: [],
    userDetail: {} as any,
    error: null,
    loading: false
};

const UsersSlice = createSlice({
    name: 'Users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get List
        builder.addCase(getUserList.fulfilled, (state: any, action: any) => {
            state.userList = action.payload.items;
            state.loading = false;
        });
        builder.addCase(getUserList.rejected, (state: any, action: any) => {
            state.error = action.error || null;
            state.loading = false;
        });
        builder.addCase(getUserList.pending, (state: any, action: any) => {
            state.error = null;
            state.loading = true;
        });

        // Get Detail
        builder.addCase(getUserDetail.fulfilled, (state: any, action: any) => {
            state.userDetail = action.payload;
        });
        builder.addCase(getUserDetail.rejected, (state: any, action: any) => {
            state.error = action.error || null;
        });
        builder.addCase(getUserDetail.pending, (state: any, action: any) => {
            state.error = null;
        });

        // Add User
        builder.addCase(addUser.fulfilled, (state: any, action: any) => {
            state.userList = [...state.userList, action.payload]
            state.error = null;
        });
        builder.addCase(addUser.rejected, (state: any, action: any) => {
            state.error = action.error || null;
        });
        builder.addCase(addUser.pending, (state: any, action: any) => {
            state.error = null;
        });

        // Update
        builder.addCase(updateUser.fulfilled, (state: any, action: any) => {
            state.userList = state.userList.map((list: any) =>
                list.id === action.payload.id
                    ? { ...list, ...action.payload }
                    : list
            );

            state.error = null;
        });
        builder.addCase(updateUser.rejected, (state: any, action: any) => {
            state.error = action.error || null;
        });
        builder.addCase(updateUser.pending, (state: any, action: any) => {
            state.error = null;
        });

        // Delete
        builder.addCase(deleteUser.fulfilled, (state: any, action: any) => {
            state.userList = state.userList.filter(
                (userList: any) => userList.id.toString() !== action.payload.toString()
            );
        });
        builder.addCase(deleteUser.rejected, (state: any, action: any) => {
            state.error = action.error || null;
        });
        builder.addCase(deleteUser.pending, (state: any, action: any) => {
            state.error = null;
        });
    }
});

export default UsersSlice.reducer;